export default "__VITE_ASSET__B$iWA62m__"